module.exports = __webpack_public_path__ + "static/media/user1.0e80da65.jpeg";